import angular from 'angular';

import component from './cta-buttons-configure.component';
const CtaButtonsConfigure = angular
    .module('control-room.commons.form.components.cta-buttons-configure', [])
    .component('crCtaButtonsConfigure', component);

export default CtaButtonsConfigure;
